import { Injectable } from '@angular/core';

import { GameBase } from './game-base';
import { BaccaratGame } from './game-types/baccarat/baccarat.game';
import { DragonTigerGame } from './game-types/dragon-tiger/dragon-tiger.game';
import { GameType } from '../models/communication/app-enums.model';
import { InitialTableState } from '../models/communication/app-state.model';
import { OpenBaccaratGame } from './game-types/open-baccarat/open-baccarat.game';
import { OpenDragonTigerGame } from './game-types/open-dragon-tiger/open-dragon-tiger.game';
import { ThreeHeadedDragonGame } from './game-types/three-headed-dragon/three-headed-dragon.game';

/**
 * Responsible for initializing all the different game types.
 * It exposes a single method that returns a
 * `GameBase` subclass instance based on a provided `GameType`.
 */
@Injectable({
    providedIn: 'root'
})
export class GameFactory {
    create(gameType: GameType, initialData?: InitialTableState): GameBase {
        switch (gameType) {
            case GameType.Baccarat:
                return new BaccaratGame(initialData);
            case GameType.OpenBaccarat:
                return new OpenBaccaratGame(initialData);
            case GameType.DragonTiger:
                return new DragonTigerGame(initialData);
            case GameType.OpenDragonTiger:
                return new OpenDragonTigerGame(initialData);
            case GameType.ThreeHeadedDragon:
                return new ThreeHeadedDragonGame(initialData);
            default:
                throw new Error('Invalid game type!');
        }
    }
}
